/**
 * Renders a sport icon from frontend/public/optimized/sports when value is a path,
 * otherwise renders the string as emoji (fallback).
 */
import React from 'react';

const EMOJI_STYLE: React.CSSProperties = {
  fontFamily: 'Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif',
};

export type SportIconSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<SportIconSize, string> = {
  sm: 'w-4 h-4',
  md: 'w-5 h-5',
  lg: 'w-6 h-6 text-xl',
};

interface SportIconProps {
  /** Value from getSportIcon() - either /optimized/sports/N.webp or emoji string */
  icon: string;
  size?: SportIconSize;
  className?: string;
}

export default function SportIcon({ icon, size = 'md', className = '' }: SportIconProps) {
  const isPath = typeof icon === 'string' && icon.startsWith('/');
  const imgClass = `${sizeClasses[size]} object-contain flex-shrink-0 ${className}`.trim();
  const spanClass = `leading-none ${size === 'lg' ? 'text-2xl' : size === 'md' ? 'text-base' : 'text-sm'} ${className}`.trim();

  if (isPath) {
    return <img src={icon} alt="" className={imgClass} />;
  }
  return (
    <span className={spanClass} style={EMOJI_STYLE}>
      {icon}
    </span>
  );
}
